"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = tealium;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var dlFunctions = _interopRequireWildcard(require("./dataLayerFunctions"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * The plugins that connect Thor to Tealium.
 * @namespace Thor.plugins.Tealium
 * @memberof Thor.plugins
 * @class
 */
function tealium(Thor) {
  if (typeof window === "undefined") return;
  var _obj = {};
  var _dl = window.utag_data = window.utag_data || {},
    _pushVariable = function _pushVariable(obj) {
      _obj = _objectSpread(_objectSpread({}, _obj), obj);
    },
    _pushEvent = function _pushEvent(evt) {
      if (evt === "view" || evt === "interaction") return;
      try {
        var push = _objectSpread({
          tealium_event: evt
        }, _obj);
        utag.ut.merge(utag.data, push, true);
        if (evt === "page_view") window.utag.view(push);else window.utag.link(push);
        _obj = {};
      } catch (e) {}
    };
  Thor.addVariablesListener(_pushVariable);
  Thor.addEventsListener(_pushEvent);
  return {
    /**
     * dataLayer of Tealium. </br>
     * That is the array who's the interface between the site and Tealium.
     * @memberof Thor.plugins.Tealium
     * @member {Object} dataLayer
     */
    dataLayer: _dl,
    /**
     * Get the dataLayer value of a given key.
     * @method
     * @name Thor.plugins.Tealium.getDataLayerValue
     * @param {String} key - The key to find into the thor's dataLayer
     * @param {Array|Object} [dl=dataLayer] - The context to launch the search, by default the plugin's dataLayer
     * @return {*} Return the value that matches the key, default value is an empty string.
     */
    getDataLayerValue: function getDataLayerValue(key) {
      var dl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _dl;
      return dlFunctions.getDataLayerValue(dl, key);
    },
    /**
     * Return the list on the dataLayer, matching the key passed in params.
     * @method
     * @name Thor.plugins.Tealium.getDataLayerListById
     * @param {String} key - The key to find into the dataLayer
     * @param {Array|Object} [dl=dataLayer] - The context to launch the search, by default the plugin's dataLayer
     * @return {Array} Return the value that matches the key, default value is an empty array.
     */
    getDataLayerListById: function getDataLayerListById(key) {
      var dl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _dl;
      return dlFunctions.getDataLayerListById(dl, key);
    },
    /**
     * Return the object on the dataLayer, matching the combo
     * key:value passed in params.
     * @method
     * @name Thor.plugins.Tealium.getDataLayerObject
     * @param {String} key - Name of the key in the thor's dataLayer
     * @param {String} val - Value to test with the key's name
     * @param {Array|Object} [dl=dataLayer] - The context to launch the search, by default the plugin's dataLayer
     * @return {Object}
     * Return the object of the dataLayer matching the combo key:value,
     * else return false.
     */
    getDataLayerObject: function getDataLayerObject(key, val) {
      var dl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _dl;
      return dlFunctions.getDataLayerObject(dl, key, val);
    },
    /**
     * Check if an element exist in the dataLayer.
     * @method
     * @name Thor.plugins.Tealium.inDataLayer
     * @param {String} key - Name of the key in the thor's dataLayer
     * @param {String} val - Value to test with the key's name
     * @param {Array|Object} [dl=dataLayer] - The context to launch the search, by default the
     * @return {Boolean}
     * Return True if the combo key: value exist in the dataLayer array,
     * else return false.
     */
    inDataLayer: function inDataLayer(key, val) {
      var dl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _dl;
      return dlFunctions.inDataLayer(dl, key, val);
    },
    /**
     * Push a non event object into the dataLayer.
     * @method
     * @name Thor.plugins.Tealium.pushVariable
     * @param {Object} obj - The oject to add into the dataLayer
     */
    pushVariable: _pushVariable,
    /**
     * Push an event into the dataLayer, with an optional object to add into the dataLayer.
     * @method
     * @name Thor.plugins.Tealium.pushEvent
     * @param {String} evt - The event to launch.
     */
    pushEvent: _pushEvent
  };
}